<template>
  <v-row>
    <v-col cols="12" sm="6">
      <h4>You currently have no barrels</h4>
      <router-link v-if="!disableWarehouse" :to="{ name: 'Order' }" class="btn btn-primary fw-bold"
        >Click here to order a barrel
      </router-link>
    </v-col>
    <v-col cols="12" sm="6">
      <img
        src="@/assets/media/barrelsandcouple-1-1@1x.png"
        alt="People and barrel"
        class="col"
      />
    </v-col>
  </v-row>
</template>
<script>
import Appsettings from "@/config/appsettings.json";

    export default {
      computed: {
        disableWarehouse() {
          return Appsettings.DisableWarehouse ?? false;
        }
      },
    };
  </script>